import { useEffect, useState } from "react"
import './index.css'
import DataTable from "../common/DataTable"
import { columns, handleDoubleClickRow } from "./scheme"
import ActionModal from "../common/ActionModal"
import ConfirmModal from "../common/ConfirmModal"
import { SubmitHandler } from "react-hook-form"
import PersonForm from "./PersonForm"
import { DataPerson, PersonFormModel, PersonProjects } from "../../models/user.model"
import { createPerson, deletePerson, editPerson, filterPersons, getPerson } from "../../services/user.service"
import useUser from "../../hooks/useUser"
import { useProject } from "../../context/ProjectContext"
import { useNotification } from "../../context/NotificationContext"


export default function PersonsListing({ setBlockScreen, openActionModal, setOpenActionModal, action,
  setAction, canEdit }: any) {
  const { user } = useUser()
  const { projectsList } = useProject()
  const { showNotification } = useNotification();


  const [loadingList, setLoadingList] = useState<boolean>(false)
  const [reloadList, setReloadList] = useState(false)

  const [personId, setPersonId] = useState<string>('')
  const [openConfirmModal, setOpenConfirmModal] = useState(false)

  const [fieldErrors, setFieldErrors] = useState<string[]>([])

  const initialForm: PersonFormModel = {
    name: '',
    last_name: '',
    email: '',
    cellphone: '',
    created_date: '',
    projects: []
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setPersonForm({
      ...personForm,
      [event.target.name]: event.target.value
    });
  }

  const [personForm, setPersonForm] = useState<PersonFormModel>(initialForm)
  const [personsList, setPersonsList] = useState<DataPerson[]>([])

  const errorFields = () => {
    let errors: string[] = []
    if (personForm.name.length === 0) errors.push('name')
    if (personForm.last_name.length === 0) errors.push('last_name')
    if (personForm.email.length === 0) errors.push('email')
    if (personForm.projects.length === 0) errors.push('projects')
    setFieldErrors(errors)

    return errors.length > 0
  }

  const initComponent = () => {
    setBlockScreen(true)
    Promise.all([]).then(function (results: any[]) {
      setBlockScreen(false)
    }).catch((error) => {
      setBlockScreen(false)
    })
  }

  useEffect(initComponent, [])

  const handleCloseDetail = () => {
    setOpenActionModal(false)
    setPersonId('')
    setAction('view')
    setPersonForm(initialForm)
    setFieldErrors([])
  }

  const fetchDataTable = () => {
    setLoadingList(true)
    Promise.all([filterPersons({ 'person_id': user.person })
    ]).then(function (result: any[]) {
      setPersonsList(result[0])
      setLoadingList(false)
    }).catch((error) => {
      showNotification(<span>Error obteniendo la lista de personas</span>, 'error')
      setLoadingList(false)
    });
  };

  useEffect(fetchDataTable, [reloadList])

  const fetchPerson = () => {
    if (personId) {
      setBlockScreen(true)
      Promise.all([getPerson(personId)
      ]).then(function (result: any[]) {
        setPersonForm(result[0])
        setOpenActionModal(true)
        setBlockScreen(false)
      }).catch((error) => {
        showNotification(<span>{error.response.data}</span>, 'error')
        setBlockScreen(false)
      });
    }
  }

  useEffect(fetchPerson, [personId])

  const onSubmitCreate: SubmitHandler<PersonFormModel> = () => {
    if (!errorFields()) {
      setBlockScreen(true)
      Promise.all([createPerson(personForm)
      ]).then(function (result: any[]) {
        setTimeout(() => {
          showNotification(<span>Se ha creado la persona <i>{personForm.name} {personForm.last_name}</i></span>)
          handleCloseDetail()
          setReloadList(!reloadList)
        }, 1000)
        setBlockScreen(false)
      }).catch((error) => {
        showNotification(<span>{error.response.data}</span>, 'error')
        setBlockScreen(false);
      });
    }
  }

  const onSubmitEdit: SubmitHandler<PersonFormModel> = () => {
    if (!errorFields()) {
      setBlockScreen(true)
      Promise.all([editPerson(personId, personForm)
      ]).then(function (result: any[]) {
        setTimeout(() => {
          showNotification(<span>Se ha editado la persona <i>{personForm.name} {personForm.last_name}</i></span>)
          handleCloseDetail()
          setReloadList(!reloadList)
        }, 1000)
        setBlockScreen(false)
      }).catch((error) => {
        showNotification(<span>{error.response.data}</span>, 'error')
        setBlockScreen(false);
      });
    }
  }

  const onSubmitDelete = () => {
    setBlockScreen(true)
    Promise.all([deletePerson(personId)
    ]).then(function (result: any[]) {
      setTimeout(() => {
        showNotification(<span>Se ha removido la persona <i>{personForm.name} {personForm.last_name}</i></span>)
        handleCloseDetail()
        setOpenConfirmModal(false)
        setReloadList(!reloadList)
      }, 1000)
      setBlockScreen(false)
    }).catch((error) => {
      showNotification(<span>{error.response.data}</span>, 'error')
      setOpenConfirmModal(false)
      setReloadList(!reloadList)
      setBlockScreen(false);
    });
  }

  const handleRemoveTitle = () => {
    setOpenConfirmModal(true)
  }

  const handleCloseConfirmRemove = () => {
    setOpenConfirmModal(false)
  }

  const handleDoubleClickTitle = (event: any) => {
    handleDoubleClickRow(event, setPersonId)
  }

  return (
    <>
      <ActionModal
        title={action === 'create' ? 'Nueva Persona' : 'Persona'}
        openModal={openActionModal}
        handleCloseModal={handleCloseDetail}
        mode={action}
        setMode={setAction}
        handleCreate={onSubmitCreate}
        handleEdit={onSubmitEdit}
        handleRemove={handleRemoveTitle}
        canEdit={canEdit}
        children={<PersonForm action={action}
          personForm={personForm}
          handleChange={handleChange}
          errors={fieldErrors}
          projectsList={projectsList}
        />}
      />

      <ConfirmModal
        openModal={openConfirmModal}
        handleCloseModal={handleCloseConfirmRemove}
        handleConfirm={onSubmitDelete}
      >
        <p>¿ Remover Persona: {personForm.name} {personForm.last_name} ?</p>
      </ConfirmModal>

      <DataTable
        columns={columns}
        rows={personsList}
        handleDoubleClick={handleDoubleClickTitle}
        loading={loadingList}
      />

    </>
  );
}
